import { withStyles } from "@material-ui/core/styles";
import StyledToolTip from "../../../../../../common/StyledToolTip";
import { getOverTimeHours } from "../../../../utils/utils";

const styles = (theme) => ({
  value: {
    cursor: "pointer",
  },
  overtime: {
    color: theme.ErrorMessageColor,
  },
});
const AccHoursRenderer = ({ accruedHours, allowedHOS, classes }) => {
  const otHours = getOverTimeHours(accruedHours, allowedHOS);
  return (
    <StyledToolTip title={otHours > 0 ? `Overtime Hours : ${otHours}` : ""}>
      <span className={`${classes.value} ${otHours ? classes.overtime : ""}`}>
        {accruedHours ? accruedHours : ""}
      </span>
    </StyledToolTip>
  );
};

export default withStyles(styles)(AccHoursRenderer);
